import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {AdvertisementsListHeader} from './components/header/AdvertisementsListHeader'
import {AdvertisementsTable} from './table/AdvertisementsTable'
import { AdvertisementEditModal } from './Advertisement-edit-modal/AdvertisementEditModal'
import {KTCard} from '../../../../_metronic/helpers'

const AdvertisementsList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <AdvertisementsListHeader />
        <AdvertisementsTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <AdvertisementEditModal />}
    </>
  )
}

const AdvertisementsListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <AdvertisementsList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {AdvertisementsListWrapper}
